<template>
    <el-dialog :visible="showDialog" title="导出任务" @close="onClose" width="30%">
        <el-form :model="formData" ref="formDataRef" :rules="rules" label-position="right" inline label-width="150px">
            <el-form-item label="派单时间" prop="dispatcherTime">
                <el-date-picker v-model="formData.dispatcherTime" value-format="yyyy-MM-dd" type="daterange" @change="onDate" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" style="width:230px" size="small" />
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button type="primary" @click="onExport" size="small">导出</el-button>
        </template>
    </el-dialog>
</template>

<script>
import { Loading } from "element-ui";
export default {
    data() {
        return {
            showDialog: false,
            formData: {
                dispatcherTime: "",
                carrierMemberId: sessionStorage.getItem("memberId")
            },
            rules: {
                dispatcherTime: [{ required: true, message: "请选择", trigger: "change" }]
            }
        };
    },
    methods: {
        openDialog() {
            this.showDialog = true;
        },
        onClose() {
            this.showDialog = false;
            this.$refs["formDataRef"].resetFields();
        },
        async onExport() {
            let validate = await this.$refs["formDataRef"].validate();
            if (!validate) return;
            this.onDownload();
        },
        async onDownload() {
            let loadingInstance = Loading.service({ text: "加载中..." });
            let params = {
                exportId: "carrierExportTaskToBeHandled",
                body: {
                    params: {
                        carrierMemberId:this.formData.carrierMemberId,
                        dispatcherTimeBegin:this.formData.dispatcherTimeBegin,
                        dispatcherTimeEnd:this.formData.dispatcherTimeEnd,

                    }
                }
            };
            let result = await this.request("/export", params, {
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                responseType: "arraybuffer"
            });
            if (result) {
                let fileName = "运输任务" + "(" + new Date().toLocaleDateString() + ")" + ".csv";
                this.pltUtil.saveFile(fileName, result);
            }
            loadingInstance.close();
        },
        onDate(val) {
            this.formData.dispatcherTimeBegin = val ? val[0] : "";
            this.formData.dispatcherTimeEnd = val ? val[1] : "";
        },
    }
};
</script>

